export const MaxAttachmentLimitInMB = 5;
